import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { useCart } from '../context/CartContext';

function Navbar() {
  const { currentUser, isAdmin, logout } = useAuth();
  const { cartCount } = useCart();
  const navigate = useNavigate();

  async function handleLogout() {
    try {
      await logout();
      navigate('/');
    } catch (err) {
      console.error('Logout failed:', err);
    }
  }

  return (
    <nav className="navbar navbar-expand-lg piggy-navbar">
      <div className="container">

        {/* Brand */}
        <Link className="navbar-brand fw-bold ls-wide" to="/" style={{ letterSpacing: '0.12em', fontSize: '1.1rem' }}>
          PORK CO.
        </Link>

        {/* Mobile toggle */}
        <button
          className="navbar-toggler border-secondary"
          type="button"
          data-bs-toggle="collapse"
          data-bs-target="#navbarMain"
          aria-controls="navbarMain"
          aria-expanded="false"
          aria-label="Toggle navigation"
        >
          <span className="navbar-toggler-icon" style={{ filter: 'invert(1)' }}></span>
        </button>

        <div className="collapse navbar-collapse" id="navbarMain">
          {/* Left links */}
          <ul className="navbar-nav me-auto mb-2 mb-lg-0">
            <li className="nav-item">
              <Link className="nav-link" to="/">Home</Link>
            </li>
            <li className="nav-item">
              <Link className="nav-link" to="/products">Shop</Link>
            </li>
            {isAdmin && (
              <li className="nav-item">
                <Link className="nav-link" style={{ color: '#c84b11' }} to="/admin">
                  Admin
                </Link>
              </li>
            )}
          </ul>

          {/* Right links */}
          <ul className="navbar-nav ms-auto mb-2 mb-lg-0 align-items-lg-center">
            <li className="nav-item">
              <Link className="nav-link position-relative" to="/cart">
                Cart
                {cartCount > 0 && (
                  <span
                    className="badge rounded-pill ms-1"
                    style={{ background: '#c84b11', fontSize: '0.65rem' }}
                  >
                    {cartCount}
                  </span>
                )}
              </Link>
            </li>

            {currentUser ? (
              <>
                <li className="nav-item">
                  <Link className="nav-link" to="/orders">My Orders</Link>
                </li>
                <li className="nav-item d-none d-lg-block">
                  <span className="nav-link small" style={{ color: '#888', cursor: 'default' }}>
                    {currentUser.email}
                  </span>
                </li>
                <li className="nav-item">
                  <button
                    className="btn btn-outline-light btn-sm ms-2"
                    style={{ borderRadius: '2px', fontSize: '0.8rem' }}
                    onClick={handleLogout}
                  >
                    Logout
                  </button>
                </li>
              </>
            ) : (
              <>
                <li className="nav-item">
                  <Link className="nav-link" to="/login">Login</Link>
                </li>
                <li className="nav-item">
                  <Link
                    className="btn btn-sm ms-2"
                    to="/signup"
                    style={{
                      background: '#c84b11',
                      color: 'white',
                      borderRadius: '2px',
                      fontWeight: 600,
                      fontSize: '0.8rem'
                    }}
                  >
                    Sign Up
                  </Link>
                </li>
              </>
            )}
          </ul>
        </div>
      </div>
    </nav>
  );
}

export default Navbar;
